import { FC, ReactNode } from 'react';
import { ROLE } from '../constants/common';

interface AdminProtectedRouteProps {
  children: ReactNode;
  fallback: ReactNode;
}

/**
 * AdminProtectedRoute - Protected route wrapper for admin-only pages
 *
 * Checks if the current user has admin role and renders children if authorized,
 * otherwise renders the fallback component.
 */
const AdminProtectedRoute: FC<AdminProtectedRouteProps> = ({
  children,
  fallback,
}) => {
  const isAdminUser =
    sessionStorage.getItem('pfz-cggenai-user-role') === ROLE.ADMIN;

  if (!isAdminUser) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default AdminProtectedRoute;
